import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'Sarkari Naukri Rajasthan';
const BASE_URL = 'https://sarkarinaukrirajasthan.com';

/**
 * Reusable SEO component — injects <title>, meta description, OG/Twitter tags,
 * canonical URL, and optional JSON-LD structured data into <head>.
 */
const SEO = ({
  title,
  description,
  path = '/',
  type = 'website',
  structuredData,
  noIndex = false,
}) => {
  const fullTitle = title ? `${title} – ${SITE_NAME}` : `${SITE_NAME} – Latest Government Jobs, Results & Admit Cards 2026`;
  const canonical = `${BASE_URL}${path}`;

  return (
    <Helmet>
      {/* Primary */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonical} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:site_name" content={SITE_NAME} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />

      {/* Robots */}
      {noIndex && <meta name="robots" content="noindex, nofollow" />}

      {/* Structured Data (JSON-LD) */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
